import http from '@/utils/http';
const base_path = '/v2/tool/businessPoint';

/** 查询行业业务点信息接口 */
export function getBusinessPointListApi(params) {
  return http.get({
    url: base_path,
    params,
  });
}
